// TAPINTO® Editor Frontend - Two Column Component
// Version: 1.0
// Date: 2025-10-01

import React from 'react';
import { useNode } from '@craftjs/core';
import { Element } from '@craftjs/core';
import { ComponentProps } from '../../../types';

interface TwoColumnProps extends ComponentProps {
  leftWidth: number;
  rightWidth: number;
  gap: string;
  backgroundColor: string;
  padding: string;
  margin: string;
}

export function TwoColumn({
  leftWidth,
  rightWidth,
  gap,
  backgroundColor,
  padding,
  margin,
  ...props
}: TwoColumnProps) {
  const {
    connectors: { connect, drag },
    isActive,
    isHovered,
  } = useNode((state) => ({
    isActive: state.events.selected,
    isHovered: state.events.hovered,
  }));

  return (
    <div
      ref={(ref) => connect(drag(ref))}
      className={`
        flex flex-col md:flex-row
        ${isActive ? 'ring-2 ring-primary-500' : ''}
        ${isHovered ? 'ring-2 ring-primary-300' : ''}
      `}
      style={{
        backgroundColor,
        padding,
        margin,
        gap,
      }}
      {...props}
    >
      {/* Left Column */}
      <div
        className="flex-1"
        style={{ flex: leftWidth }}
      >
        <Element
          id="left-column"
          is="div"
          canvas
          className="min-h-[100px] p-4 border-2 border-dashed border-neutral-300 rounded"
        >
          <div className="text-center text-neutral-500 text-sm">
            Drop content here
          </div>
        </Element>
      </div>

      {/* Right Column */}
      <div
        className="flex-1"
        style={{ flex: rightWidth }}
      >
        <Element
          id="right-column"
          is="div"
          canvas
          className="min-h-[100px] p-4 border-2 border-dashed border-neutral-300 rounded"
        >
          <div className="text-center text-neutral-500 text-sm">
            Drop content here
          </div>
        </Element>
      </div>
    </div>
  );
}

TwoColumn.craft = {
  displayName: 'Two Column Layout',
  props: {
    leftWidth: 1,
    rightWidth: 1,
    gap: '24px',
    backgroundColor: 'transparent',
    padding: '24px',
    margin: '0',
  },
  rules: {
    canDrag: () => true,
    canMoveIn: () => true,
    canMoveOut: () => true,
  },
};
